module.exports = __webpack_public_path__ + "img/Grenada.f06de1c7.svg";